import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { styled } from "@mui/material";
import { Button } from "components";
import { Undo, RestartAlt } from "@mui/icons-material";

const WrapperStyled = styled("div")(({ theme }) => ({
  // borderTop: "1px solid #ccc",
  "&.hidden": {
    height: "50px",
    visibility: "hidden",
  },
  "& p": {
    fontWeight: "bold",
    textAlign: "center",
    padding: "0 10px",
    margin: "10px 0",
  },
  "& .buttons-container": {
    display: "flex",
    justifyContent: "flex-end",
    margin: "7.5px 0",
    paddingRight: "10px",
    "& button": {
      color: theme.navbarColors.background,
    },
  },
}));

const ChatbotEndConversationUnstyled = ({
  className,
  isVisible,
  onReset,
  onUndo,
}) => {
  const { t } = useTranslation();

  return (
    <WrapperStyled className={clsx(className, { hidden: !isVisible })}>
      {/* <p>{t("Chatbot.ThanksMessage")}</p> */}
      <div className="buttons-container">
        <Button variant="text" onClick={onUndo}>
          <Undo sx={{ marginRight: "5px" }} />
          {t("Chatbot.UndoButton")}
        </Button>
        <Button variant="text" onClick={onReset}>
          <RestartAlt sx={{ marginRight: "5px" }} />
          {t("Chatbot.RestartButton")}
        </Button>
      </div>
    </WrapperStyled>
  );
};

const ChatbotEndConversation = styled(ChatbotEndConversationUnstyled)({});

export default ChatbotEndConversation;
